import { formatPhoneNumberIntl } from "react-phone-number-input";

// [PATIENT-CHANNELS] Creating a patient with a phone that already belongs to
// a live customer of the org no longer makes a duplicate: POST /patients/
// answers 200 with the existing record plus `already_exists: true` and
// `recipient_name` (the name typed in the form; the record keeps its own).
// A new patient answers 201 with `already_exists: false`.

const normalizeName = (name) =>
  (name || "").toString().split(/\s+/).filter(Boolean).join(" ");

export const patientFullName = (patient) =>
  normalizeName(`${patient?.first_name || ""} ${patient?.last_name || ""}`) ||
  normalizeName(patient?.full_name);

// Splits a create answer into the patient record and the facts about the
// call, so the flags never end up on a stored row (and from there in a PATCH).
export const parsePatientCreateResult = (payload) => {
  const { already_exists, recipient_name, ...patient } = payload || {};
  return {
    patient,
    alreadyExists: Boolean(already_exists),
    typedName: normalizeName(recipient_name),
  };
};

// The name an order for this customer should go under (Order.recipient_name):
// the typed one, only when it is not the record's own name — blank on the
// order means "use the customer's".
export const recipientNameFor = (patient, typedName) => {
  const typed = normalizeName(typedName);
  if (!typed) {
    return undefined;
  }
  return typed.toLowerCase() === patientFullName(patient).toLowerCase()
    ? undefined
    : typed;
};

// "Jane Doe (+1 555 123 4567) — <action>"
export const alreadyOnFileText = (patient, action) => {
  const rawPhone = patient?.phone_number || "";
  const phone = rawPhone ? formatPhoneNumberIntl(rawPhone) || rawPhone : "";
  const who = [patientFullName(patient), phone ? `(${phone})` : ""]
    .filter(Boolean)
    .join(" ");
  return `${who} — ${action}`;
};
